import { render } from "./ResourceItem.vue?vue&type=template&id=6990c398&scoped=true"
import script from "./ResourceItem.vue?vue&type=script&lang=js"
export * from "./ResourceItem.vue?vue&type=script&lang=js"

import "./ResourceItem.vue?vue&type=style&index=0&id=6990c398&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3953904547/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6990c398"]])

export default __exports__